/* Promocion en bottom sheet. Ver snippets/hai-cross-sell.liquid.

   Este archivo no sabe que producto se promueve: todo lo declara el
   markup (data-variante, data-codigo). Para cambiar la oferta se toca
   el snippet, no este script.

   Todo va con guardas y falla en silencio: esto corre sobre el tema
   publicado de una tienda con trafico real, y una oferta jamas puede
   estorbar una compra. */

(function () {
  'use strict';

  if (window.__haiCrossSell) return;
  window.__haiCrossSell = true;

  var raiz = document.querySelector('[data-hai-cs]');
  if (!raiz) return;

  var sheet = raiz.querySelector('.hai-cs__sheet');
  var btnAdd = raiz.querySelector('[data-hai-cs-add]');
  if (!sheet || !btnAdd) return;

  /* Milisegundos desde que se entra a la home hasta que sube la oferta.
     Andrés (09-sep-2026): a los 5 s "sale muy rápido"; se sube a 10 s. */
  var ESPERA = 10000;

  var MOVIL = '(max-width: 749px)';
  var CLAVE = 'haiCrossSellVista';
  var abierto = false;

  var idVariante = parseInt(raiz.getAttribute('data-variante'), 10);

  function esMovil() {
    return window.matchMedia && window.matchMedia(MOVIL).matches;
  }

  /* Una vez por sesion: quien ya la vio no la vuelve a recibir al navegar
     de vuelta a la portada. */
  function yaVisto() {
    try { return sessionStorage.getItem(CLAVE) === '1'; } catch (e) { return false; }
  }
  function marcarVisto() {
    try { sessionStorage.setItem(CLAVE, '1'); } catch (e) { /* modo privado */ }
  }

  function abrir() {
    if (abierto || yaVisto() || !esMovil()) return;

    /* Si justo hay un overlay del tema abierto (el menu, el buscador), se
       espera a que cierre en vez de apilarse encima. El tema marca
       `body.hidden` mientras uno de los suyos esta abierto. */
    if (document.body.classList.contains('hidden')) {
      var observador = new MutationObserver(function () {
        if (!document.body.classList.contains('hidden')) {
          observador.disconnect();
          window.setTimeout(abrir, 600);
        }
      });
      observador.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      return;
    }

    abierto = true;
    marcarVisto();
    raiz.classList.add('hai-cs--abierto');
    sheet.setAttribute('aria-hidden', 'false');
  }

  function cerrar() {
    if (!abierto) return;
    abierto = false;
    raiz.classList.remove('hai-cs--abierto');
    sheet.setAttribute('aria-hidden', 'true');
    sheet.style.transform = '';
  }

  /* Disparador unico: entrar a la home. Sin enganches al carrito. */
  if (esMovil() && !yaVisto()) {
    window.setTimeout(abrir, ESPERA);
  }

  /* Cerrar: backdrop, grabber, "Ahora no" y Escape. */
  raiz.addEventListener('click', function (evento) {
    if (evento.target.closest('[data-hai-cs-close]')) cerrar();
  });
  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') cerrar();
  });

  /* Copiar el codigo de descuento. */
  var btnCopiar = raiz.querySelector('[data-hai-cs-copy]');
  if (btnCopiar) {
    btnCopiar.addEventListener('click', function () {
      var codigo = raiz.getAttribute('data-codigo') || '';
      var listo = function () {
        btnCopiar.textContent = 'Copiado';
        window.setTimeout(function () { btnCopiar.textContent = 'Copiar'; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(listo, listo);
      } else {
        listo();
      }
    });
  }

  /* Deja el descuento aplicado en la sesion para que el cliente no tenga
     que copiar y pegar el codigo en la caja. `/discount/CODIGO` es el
     endpoint propio de Shopify: se pide con redirect a /cart.js para que
     la respuesta sea un JSON liviano y no la home entera.

     Es un extra, no una promesa: si falla, el codigo sigue visible y
     copiable, y el texto del cupon ("al pagar") es cierto en ambos
     casos. Por eso el error se traga en silencio. */
  function aplicarDescuento() {
    var codigo = raiz.getAttribute('data-codigo');
    if (!codigo) return;
    try {
      fetch('/discount/' + encodeURIComponent(codigo) + '?redirect=/cart.js', {
        credentials: 'same-origin'
      }).catch(function () {});
    } catch (e) { /* sin descuento automatico: queda el codigo a la vista */ }
  }

  /* Agregar al carrito con el patron del proyecto: una llamada con las
     secciones del drawer del tema, para que quede actualizado sin
     recargar la pagina. */
  btnAdd.addEventListener('click', function () {
    var etiqueta = btnAdd.textContent;
    var drawer = document.querySelector('cart-drawer');
    var cuerpo = {
      items: [{ id: idVariante, quantity: 1 }]
    };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      cuerpo.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }

    btnAdd.disabled = true;
    btnAdd.textContent = 'Agregando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) {
          btnAdd.textContent = 'No se pudo agregar';
          return;
        }
        aplicarDescuento();
        cerrar();
        if (drawer && typeof drawer.renderContents === 'function' && r.data.sections) {
          drawer.renderContents(r.data);
        }
      })
      .catch(function () {
        btnAdd.textContent = 'No se pudo agregar';
      })
      .finally(function () {
        window.setTimeout(function () {
          btnAdd.disabled = false;
          btnAdd.textContent = etiqueta;
        }, 1200);
      });
  });

  /* Arrastrar hacia abajo para cerrar: el gesto que hace que un sheet se
     sienta nativo. Sin umbral no se distingue de un scroll accidental. */
  var arrastrando = false;
  var inicioY = 0;
  var delta = 0;

  function inicio(evento) {
    if (!abierto) return;
    arrastrando = true;
    delta = 0;
    inicioY = evento.touches ? evento.touches[0].clientY : evento.clientY;
    sheet.classList.add('hai-cs--arrastrando');
  }
  function mover(evento) {
    if (!arrastrando) return;
    var y = evento.touches ? evento.touches[0].clientY : evento.clientY;
    delta = Math.max(0, y - inicioY);
    sheet.style.transform = 'translateY(' + delta + 'px)';
  }
  function fin() {
    if (!arrastrando) return;
    arrastrando = false;
    sheet.classList.remove('hai-cs--arrastrando');
    if (delta > 110) {
      cerrar();
    } else {
      sheet.style.transform = 'translateY(0)';
    }
  }

  var grabber = raiz.querySelector('.hai-cs__grab');
  if (grabber) {
    grabber.addEventListener('touchstart', inicio, { passive: true });
    window.addEventListener('touchmove', mover, { passive: true });
    window.addEventListener('touchend', fin);
  }
})();
